import { render, staticRenderFns } from "./EnterForeignCertificate.vue?vue&type=template&id=926f81f6"
import script from "./EnterForeignCertificate.vue?vue&type=script&lang=ts"
export * from "./EnterForeignCertificate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports